import { PessoaCatalogo } from '../../model/geral/pessoaCatalogo';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';

@Injectable({
  providedIn: 'root'
})
export class PessoaCatalogoService extends GenericService<PessoaCatalogo>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("pessoacatalogo")
  }
}
